import _ from "lodash";
import { DefaultTheme } from "styled-components";
import Color from "color";

// cspell:disable

const rawDaisyUIthemes = {
  aqua: {
    primary: "#42e3ff",
    "primary-focus": "#0fdbff",
    "primary-content": "#000000",
    secondary: "#966fb3",
    "secondary-focus": "#7d539d",
    "secondary-content": "#ffffff",
    accent: "#132795",
    "accent-focus": "#ffde66",
    "accent-content": "#ffffff",
    neutral: "#132795",
    "neutral-focus": "#18277c",
    "neutral-content": "#ffffff",
    "base-100": "#0b25b7",
    "base-200": "#132795",
    "base-300": "#18277c",
    "base-content": "#ffffff",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  bumblebee: {
    primary: "#f9d72f",
    "primary-focus": "#edc707",
    "primary-content": "#181830",
    secondary: "#e0a82e",
    "secondary-focus": "#bf8b1d",
    "secondary-content": "#ffffff",
    accent: "#181830",
    "accent-focus": "#111122",
    "accent-content": "#ffffff",
    neutral: "#181830",
    "neutral-focus": "#111122",
    "neutral-content": "#ffffff",
    "base-100": "#ffffff",
    "base-200": "#f5f5f5",
    "base-300": "#e3e3e3",
    "base-content": "#000000",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  cmyk: {
    primary: "#45AEEE",
    "primary-focus": "#3d9bd6",
    "primary-content": "#000000",
    secondary: "#E8488A",
    "secondary-focus": "#ce407b",
    "secondary-content": "#000000",
    accent: "#E8488A",
    "accent-focus": "#ddd12c",
    "accent-content": "#000000",
    neutral: "#1a1a1a",
    "neutral-focus": "#000000",
    "neutral-content": "#ffffff",
    "base-100": "#ffffff",
    "base-200": "#f5f5f5",
    "base-300": "#ebebeb",
    "base-content": "#000000",
    info: "#4AA8C0",
    success: "#823290",
    warning: "#EE8133",
    error: "#E93F33",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  corporate: {
    primary: "#4b6bfb",
    "primary-focus": "#1942fa",
    "primary-content": "#181a2a",
    secondary: "#7b92b2",
    "secondary-focus": "#5c789d",
    "secondary-content": "#181a2a",
    accent: "#67cba0",
    "accent-focus": "#41be88",
    "accent-content": "#181a2a",
    neutral: "#181a2a",
    "neutral-focus": "#06060a",
    "neutral-content": "#edf2f7",
    "base-100": "#ffffff",
    "base-200": "#f7fafd",
    "base-300": "#edf2f7",
    "base-content": "#181a2a",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0",
    "--animation-input": "0",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "1",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  cupcake: {
    primary: "#65c3c8",
    "primary-focus": "#42b2b8",
    "primary-content": "#ffffff",
    secondary: "#ef9fbc",
    "secondary-focus": "#e8739e",
    "secondary-content": "#ffffff",
    accent: "#e8739e",
    "accent-focus": "#e19914",
    "accent-content": "#ffffff",
    neutral: "#291334",
    "neutral-focus": "#200f29",
    "neutral-content": "#ffffff",
    "base-100": "#faf7f5",
    "base-200": "#efeae6",
    "base-300": "#e7e2df",
    "base-content": "#291334",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "1.9rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "2px",
    "--tab-radius": ".5rem",
  },
  cyberpunk: {
    fontFamily:
      "ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace",
    primary: "#ff5784",
    "primary-focus": "#ff5784",
    "primary-content": "#000000",
    secondary: "#75d1f0",
    "secondary-focus": "#5abfdd",
    "secondary-content": "#000000",
    accent: "#c07eec",
    "accent-focus": "#af59e8",
    "accent-content": "#000000",
    neutral: "#423f00",
    "neutral-focus": "#090901",
    "neutral-content": "#ffee00",
    "base-100": "#ffee00",
    "base-200": "#dbcd00",
    "base-300": "#b8ab00",
    "base-content": "#000000",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "var(--b3)",
    "--rounded-box": "0",
    "--rounded-btn": "0",
    "--rounded-badge": "0",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0",
  },
  purp: {
    primary: "#793ef9",
    "primary-focus": "#570df8",
    "primary-content": "#ffffff",
    secondary: "#f000b8",
    "secondary-focus": "#bd0091",
    "secondary-content": "#ffffff",
    accent: "#793ef9",
    "accent-focus": "#2aa79b",
    "accent-content": "#ffffff",
    neutral: "#2a2e37",
    "neutral-focus": "#16181d",
    "neutral-content": "#ffffff",
    "base-100": "#3d4451",
    "base-200": "#2a2e37",
    "base-300": "#16181d",
    "base-content": "#ebecf0",
    info: "#66c6ff",
    success: "#87d039",
    warning: "#e2d562",
    error: "#ff6f6f",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  dracula: {
    primary: "#ff80bf",
    "primary-focus": "#ff80bf",
    "primary-content": "#1d1e25",
    secondary: "#b9ffb3",
    "secondary-focus": "#8aff80",
    "secondary-content": "#1d1e25",
    accent: "#1d1e25",
    "accent-focus": "#ffff80",
    "accent-content": "#1d1e25",
    neutral: "#22212c",
    "neutral-focus": "#1d1e25",
    "neutral-content": "#d5ccff",
    "base-100": "#302f3d",
    "base-200": "#22212c",
    "base-300": "#1d1e25",
    "base-content": "#d5ccff",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  emerald: {
    primary: "#66cc8a",
    "primary-focus": "#40bf6c",
    "primary-content": "#f9fafb",
    secondary: "#377cfb",
    "secondary-focus": "#055bfa",
    "secondary-content": "#f9fafb",
    accent: "#66cc8a",
    "accent-focus": "#d43616",
    "accent-content": "#f9fafb",
    neutral: "#333c4d",
    "neutral-focus": "#1f242e",
    "neutral-content": "#f9fafb",
    "base-100": "#ffffff",
    "base-200": "#f9fafb",
    "base-300": "#f2f2f2",
    "base-content": "#333c4d",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0",
    "--animation-input": "0",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "1",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  fantasy: {
    primary: "#007ebd",
    "primary-focus": "#420746",
    "primary-content": "#ffffff",
    secondary: "#007ebd",
    "secondary-focus": "#005c8a",
    "secondary-content": "#ffffff",
    accent: "#005c8a",
    "accent-focus": "#cb6c06",
    "accent-content": "#ffffff",
    neutral: "#1f2937",
    "neutral-focus": "#111827",
    "neutral-content": "#ffffff",
    "base-100": "#ffffff",
    "base-200": "#f9fafb",
    "base-300": "#d1d5db",
    "base-content": "#1f2937",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  forest: {
    primary: "#d99330",
    "primary-focus": "#178c40",
    "primary-content": "#ffffff",
    secondary: "#1fd65f",
    "secondary-focus": "#18aa4b",
    "secondary-content": "#ffffff",
    accent: "#18aa4b",
    "accent-focus": "#b57721",
    "accent-content": "#ffffff",
    neutral: "#110e0e",
    "neutral-focus": "#060404",
    "neutral-content": "#ffffff",
    "base-100": "#171212",
    "base-200": "#110e0e",
    "base-300": "#060404",
    "base-content": "#ffffff",
    // "--rounded-btn": "1.9rem",
    info: "#66c6ff",
    success: "#87d039",
    warning: "#e2d562",
    error: "#ff6f6f",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  garden: {
    primary: "#cde2c1",
    "primary-focus": "#48614f",
    "primary-content": "#ffffff",
    secondary: "#ecf4e7",
    "secondary-focus": "#cde2c1",
    "secondary-content": "#24331a",
    accent: "#48614f",
    "accent-focus": "#f4bebe",
    "accent-content": "#322020",
    neutral: "#5d5656",
    "neutral-focus": "#2a2727",
    "neutral-content": "#e9e7e7",
    "base-100": "#e9e7e7",
    "base-200": "#d1cccc",
    "base-300": "#b9b1b1",
    "base-content": "#100f0f",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  halloween: {
    primary: "#f28c18",
    "primary-focus": "#ca710c",
    "primary-content": "#131616",
    secondary: "#6d3a9c",
    "secondary-focus": "#532c77",
    "secondary-content": "#ffffff",
    accent: "#51a800",
    "accent-focus": "#397500",
    "accent-content": "#ffffff",
    neutral: "#1b1d1d",
    "neutral-focus": "#131616",
    "neutral-content": "#ffffff",
    "base-100": "#212121",
    "base-200": "#1b1d1d",
    "base-300": "#131616",
    "base-content": "#ffffff",
    info: "#66c6ff",
    success: "#87d039",
    warning: "#e2d562",
    error: "#ff6f6f",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  lipstick: {
    primary: "#e000b8",
    "primary-focus": "#4506cb",
    "primary-content": "#ffffff",
    secondary: "#f000b8",
    "secondary-focus": "#bd0091",
    "secondary-content": "#ffffff",
    accent: "#4506cb",
    "accent-focus": "#2aa79b",
    "accent-content": "#ffffff",
    neutral: "#3d4451",
    "neutral-focus": "#2a2e37",
    "neutral-content": "#ffffff",
    "base-100": "#ffffff",
    "base-200": "#f9fafb",
    "base-300": "#d1d5db",
    "base-content": "#1f2937",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  lofi: {
    primary: "#808080",
    "primary-focus": "#737373",
    "primary-content": "#f2f2f3",
    secondary: "#4d4d4d",
    "secondary-focus": "#404040",
    "secondary-content": "#f2f2f3",
    accent: "#1a1a1a",
    "accent-focus": "#0d0d0d",
    "accent-content": "#f2f2f3",
    neutral: "#f2f2f3",
    "neutral-focus": "#e4e4e7",
    "neutral-content": "#4d4d4d",
    "base-100": "#ffffff",
    "base-200": "#ffffff",
    "base-300": "#ffffff",
    "base-content": "#7d7d7d",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "#e6e6e6",
    "--rounded-box": "0",
    "--rounded-btn": "0",
    "--rounded-badge": "0",
    "--animation-btn": "0",
    "--animation-input": "0",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "1",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0",
    "*:where(.btn)": {
      "border-color": "var(--border-color) !important",
      "--tw-border-opacity": "1 !important",
      "--tw-text-opacity": "1 !important",
      "--tw-shadow": "0 0 0 1px var(--border-color) !important",
    },
    "*:where(.mockup-code)": {
      "border-color": "var(--border-color) !important",
      "--tw-border-opacity": "1 !important",
      "--tw-text-opacity": "1 !important",
      "--tw-shadow": "0 0 0 1px var(--border-color) !important",
    },
    "*:where(.mockup-window)": {
      "border-color": "var(--border-color) !important",
      "--tw-border-opacity": "1 !important",
      "--tw-text-opacity": "1 !important",
      "--tw-shadow": "0 0 0 1px var(--border-color) !important",
    },
    "*:where(.badge)": {
      "border-color": "var(--border-color) !important",
      "--tw-border-opacity": "1 !important",
      "--tw-text-opacity": "1 !important",
      "--tw-shadow": "0 0 0 1px var(--border-color) !important",
    },
    "*:where(.card)": {
      "border-color": "var(--border-color) !important",
      "--tw-border-opacity": "1 !important",
      "--tw-text-opacity": "1 !important",
      "--tw-shadow": "0 0 0 1px var(--border-color) !important",
    },
  },
  desaturated: {
    primary: "#ffffff",
    "primary-focus": "#e6e6e6",
    "primary-content": "#000000",
    secondary: "#152747",
    "secondary-focus": "#091120",
    "secondary-content": "#ffffff",
    accent: "#513448",
    "accent-focus": "#32202c",
    "accent-content": "#ffffff",
    neutral: "#171618",
    "neutral-focus": "#2e2d2f",
    "neutral-content": "#dca54c",
    "base-100": "#09090b",
    "base-200": "#171618",
    "base-300": "#2e2d2f",
    "base-content": "#dca54c",
    info: "#66c6ff",
    success: "#87d039",
    warning: "#e2d562",
    error: "#ff6f6f",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  pastel: {
    primary: "#70acc7",
    "primary-focus": "#b9a2c3",
    "primary-content": "#70acc7",
    secondary: "#f6cbd1",
    "secondary-focus": "#eea0aa",
    "secondary-content": "#ffffff",
    accent: "#d1c1d7",
    "accent-focus": "#8cdec0",
    "accent-content": "#ffffff",
    neutral: "#70acc7",
    "neutral-focus": "#4b96b9",
    "neutral-content": "#ffffff",
    "base-100": "#ffffff",
    "base-200": "#f9fafb",
    "base-300": "#d1d5db",
    "base-content": "#898d90",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    // "--rounded-box": "1rem",
    // "--rounded-btn": "1.9rem",
    // "--rounded-badge": "1.9rem",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "1.9rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  retro: {
    fontFamily: "uisecondaryerif,Georgia,Cambria,Times New Roman,Times,serif",
    primary: "#ef9995",
    "primary-focus": "#e86f68",
    "primary-content": "#282425",
    secondary: "#a4cbb4",
    "secondary-focus": "#84b89a",
    "secondary-content": "#282425",
    accent: "#ebdc99",
    "accent-focus": "#e2cd6e",
    "accent-content": "#282425",
    neutral: "#7d7259",
    "neutral-focus": "#454035",
    "neutral-content": "#e4d8b4",
    "base-100": "#e4d8b4",
    "base-200": "#d2c59d",
    "base-300": "#c6b386",
    "base-content": "#282425",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "var(--b3)",
    "--rounded-box": "0.4rem",
    "--rounded-btn": "0.4rem",
    "--rounded-badge": "0.4rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  synthwave: {
    primary: "#e779c1",
    "primary-focus": "#e04dac",
    "primary-content": "#201047",
    "secondary-focus": "#88d7f7",
    secondary: "#58c7f3",
    "secondary-content": "#201047",
    "accent-focus": "#f6d860",
    accent: "#f3cc30",
    "accent-content": "#201047",
    neutral: "#20134e",
    "neutral-focus": "#140a2e",
    "neutral-content": "#f9f7fd",
    "base-100": "#2d1b69",
    "base-200": "#20134e",
    "base-300": "#140a2e",
    "base-content": "#f9f7fd",
    info: "#53c0f3",
    success: "#71ead2",
    warning: "#f3cc30",
    error: "#e24056",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "0.5rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  valentine: {
    primary: "#e96d7b",
    "primary-focus": "#e24053",
    "primary-content": "#ffffff",
    secondary: "#a991f7",
    "secondary-focus": "#8462f4",
    "secondary-content": "#ffffff",
    accent: "#88dbdd",
    "accent-focus": "#61cfd1",
    "accent-content": "#ffffff",
    neutral: "#af4670",
    "neutral-focus": "#883a54",
    "neutral-content": "#f0d6e8",
    "base-100": "#f0d6e8",
    "base-200": "#e9aad9",
    "base-300": "#e58fce",
    "base-content": "#632c3b",
    info: "#2094f3",
    success: "#009485",
    warning: "#ff9900",
    error: "#ff5724",
    "--border-color": "var(--b3)",
    "--rounded-box": "1rem",
    "--rounded-btn": "1.9rem",
    "--rounded-badge": "1.9rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.5rem",
  },
  wireframe: {
    fontFamily: 'Chalkboard,comic sans ms,"sanssecondaryerif"',
    primary: "#b8b8b8",
    "primary-focus": "#b8b8b8",
    "primary-content": "#000000",
    secondary: "#b8b8b8",
    "secondary-focus": "#b8b8b8",
    "secondary-content": "#000000",
    accent: "#b8b8b8",
    "accent-focus": "#b8b8b8",
    "accent-content": "#000000",
    "base-100": "#ffffff",
    "base-200": "#eeeeee",
    "base-300": "#dddddd",
    "base-content": "#000000",
    neutral: "#ebebeb",
    "neutral-focus": "#ebebeb",
    "neutral-content": "#000000",
    info: "#0000ff",
    success: "#008000",
    warning: "#a6a659",
    error: "#ff0000",
    "--border-color": "#000000",
    "--rounded-box": "0.2rem",
    "--rounded-btn": "0.2rem",
    "--rounded-badge": "0.2rem",
    "--animation-btn": "0.25s",
    "--animation-input": ".2s",
    "--btn-text-case": "uppercase",
    "--btn-focus-scale": "0.95",
    "--navbar-padding": ".5rem",
    "--border-btn": "1px",
    "--tab-border": "1px",
    "--tab-radius": "0.2rem",
    "*": {
      "border-color": "var(--border-color) !important",
      "--tw-border-opacity": "1 !important",
      "--tw-text-opacity": "1 !important",
      "--tw-shadow": "0 0 0 1px var(--border-color) !important",
    },
  },
};

const daisyUIThemes: Record<keyof typeof rawDaisyUIthemes, DefaultTheme> =
  _.mapValues(rawDaisyUIthemes, (rawDaisyUItheme) => {
    let primaryBg = new Color(rawDaisyUItheme.primary).lighten(0.5).hex();
    if (primaryBg === "#FFFFFF") {
      primaryBg = new Color(rawDaisyUItheme.primary).lighten(0.3).hex();
    }
    if (primaryBg === "#FFFFFF") {
      primaryBg = rawDaisyUItheme.primary;
    }

    return {
      colors: {
        backgroundColor: primaryBg,
        textBackgroundColor: primaryBg,
        textColor: rawDaisyUItheme["primary-content"],
        dotColor: rawDaisyUItheme.secondary,
        borderColor: rawDaisyUItheme.accent,
      },
      borderRadius: rawDaisyUItheme["--rounded-box"],
      fontFamily:
        "fontFamily" in rawDaisyUItheme
          ? rawDaisyUItheme.fontFamily
          : '"Computer Modern Serif", serif',
    };
  });

export default daisyUIThemes;
